import { render, staticRenderFns } from "./contentBottom.vue?vue&type=template&id=dc87489a"
import script from "./contentBottom.vue?vue&type=script&lang=js"
export * from "./contentBottom.vue?vue&type=script&lang=js"
import style0 from "./contentBottom.vue?vue&type=style&index=0&id=dc87489a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports